import { render, staticRenderFns } from "./NfeSimples.vue?vue&type=template&id=79c31adc&scoped=true"
import script from "./NfeSimples.vue?vue&type=script&lang=js"
export * from "./NfeSimples.vue?vue&type=script&lang=js"
import style0 from "./NfeSimples.vue?vue&type=style&index=0&id=79c31adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c31adc",
  null
  
)

export default component.exports